export interface JobData {
  createdBy: string;
  createdAt: string;
  updatedBy: string | null;
  updatedAt: string;
  updateCount: number;
  deletedAt: string | null;
  deletedBy: string | null;
  id: string;
  interviewType: string;
  position: string | null;
  startDate: string;
  jobDurationFrom: number;
  jobDurationTo: number;
  city: string;
  state: string;
  zip: number;
  workType: string;
  payRangeFrom: string;
  payRangeTo: string;
  workStatus: string | null;
  projectRole: string;
  notes: string;
  positionType: string;
  education: string;
  educationNotes: string;
  jobTitle: string;
  publish: boolean;
  organizationId: string;
  archive: boolean;
  status: string;
  customerId: string;
  certificates: string;
  payRateType: string;
  salaryDesired: number;
  jobDescription: string;
  expectedResumeScore: string;
  sourceOfCreation: string;
  jobSource: string | null;
  expFrom: number | null;
  expTo: number | null;
  totalMatchedCandidates: number;
  totalCandidatesSubmitted: number;
  user: JobUser;
  customer: JobCustomer;
  files: string | null;
  jobWorkStatus: JobWorkStatus[];
  jobSkills: JobSkill[];
  totalResumes: string;
  usersAssigned: JobUserAssigned[];
  candidateMatchStatus?: string;
}

export interface JobUser {
  id: string;
  firstName: string;
  lastName: string;
  status: boolean;
}

export interface JobCustomer {
  id: string;
  name: string;
  status: boolean;
  isTemporary: boolean;
}

export interface JobWorkStatus {
  id: string;
  workStatusId: string;
  jobId: string;
  workStatus: WorkStatus;
}

export interface WorkStatus {
  id: string;
  name: string;
  status: boolean;
}

export interface JobSkill {
  id: string;
  skillId: string;
  jobId: string;
  required: number;
  preffered: number;
  deletedBy: string | null;
  skill: Skill;
}

export interface Skill {
  id: string;
  name: string;
  status: boolean;
  primary: boolean;
}

export interface JobUserAssigned {
  id: string;
  jobId: string;
  userId: string;
  createdBy: string;
  assignedByUserName: string;
  assignedToUserName: string;
  assignedByImageId: string;
  assignedToImageId: string | null;
  assignedByFirstName: string;
  assignedByLastName: string;
  assignedToFirstName: string;
  assignedToLastName: string;
}

export interface User {
  createdBy: string;
  createdAt: string;
  updatedBy: string | null;
  updatedAt: string;
  updateCount: number;
  deletedAt: string | null;
  deletedBy: string | null;
  id: string;
  empCode: string;
  firstName: string;
  lastName: string;
  roleId: number;
  organizationId: string;
  imageId: string | null;
  countryCode: string;
  phoneNumber: string;
  city: string | null;
  state: string | null;
  country: string | null;
  zip: string | null;
  status: boolean;
  archive: boolean;
  ipStatus: boolean;
  ssoId: string;
  login: {
    email: string;
  };
  role: {
    id: number;
    code: string;
    role: string;
    status: boolean;
  };
  profileImage: string | null;
  organization: {
    createdBy: string | null;
    createdAt: string;
    updatedBy: string | null;
    updatedAt: string;
    updateCount: number;
    deletedAt: string | null;
    deletedBy: string | null;
    id: string;
    name: string;
    city: string | null;
    state: string | null;
    zip: string | null;
    email: string | null;
    countryCode: string | null;
    phoneNumber: string | null;
    status: boolean;
  };
}

export interface WorkStatus {
  id: string;
  name: string;
}

export interface Candidate {
  id: string;
  ceipalId: string;
  applicantId: string;
  benchId: string;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  phone: string;
  city: string;
  state: string;
  country: string;
  applicantStatus: string;
  workPreference: string;
  benchStatus: string;
  applicantStatusDate: string; // ISO date string
  workAuth: string;
  workAuthId: string;
  benchAvailability: string;
  benchAge: string;
  address: string;
  source: string;
  pocEmail: string;
  organizationId: string;
  pocUserId: string;
  status: string;
  consultantName: string;
  otherName: string;
  aadharNumber: number;
  homePhone: string;
  otherPhone: string;
  workPhone: string;
  countryCode: string;
  mobileNumber: string;
  workStatus: WorkStatus;
  candidateSkills: CandidateSkill[];
}

export interface SubmittedOrShortlistedUser {
  id: string;
  firstName: string;
  lastName: string;
  empCode: string;
  roleId: number;
}

export interface CandidateSubmissionType {
  id: string;
  rank: number;
  matchPercentage: number;
  interviewRecommended: string;
  recommendation: string;
  status: boolean;
  isSubmitted: boolean;
  submittedAt: string; // ISO date string
  isShortlisted: boolean;
  shortlistedAt: string; // ISO date string
  candidate: Candidate;
  submittedUser: SubmittedOrShortlistedUser;
  shortlistedUser: SubmittedOrShortlistedUser;
}

export interface CandidateSkill {
  id: string;
  candidateId: string;
  skill: Skill;
}

export interface Skill {
  id: string;
  name: string;
  primary: boolean;
  status: boolean;
  alias: Alias;
}

export interface Alias {
  id: string;
  name: string;
}

export const SampleData = [
  {
    candidate: {
      aadharNumber: 123456789012,
      address: '123 Tech Park',
      applicantId: 'APP-101',
      applicantStatus: 'Active',
      applicantStatusDate: '2025-02-05',
      benchAge: '2 weeks',
      benchAvailability: 'Immediate',
      benchId: 'BEN-101',
      benchStatus: 'Available',
      candidateSkills: [
        {
          candidateId: 'cand-001',
          id: 'cs-001',
          skill: {
            alias: {
              id: 'alias-001',
              name: 'Frontend',
            },
            id: 'skill-001',
            name: 'React.js',
            primary: true,
            status: true,
          },
        },
        {
          candidateId: 'cand-001',
          id: 'cs-002',
          skill: {
            alias: {
              id: 'alias-002',
              name: 'JavaScript Framework',
            },
            id: 'skill-002',
            name: 'TypeScript',
            primary: false,
            status: true,
          },
        },
      ],
      ceipalId: 'CEI-101',
      city: 'Chennai',
      consultantName: 'TechSource',
      country: 'India',
      countryCode: '+91',
      email: 'john.doe@example.com',
      firstName: 'John',
      homePhone: '044-23456789',
      id: 'cand-001',
      lastName: 'Doe',
      middleName: 'A.',
      mobileNumber: '9876543210',
      organizationId: 'ORG-001',
      otherName: 'JD',
      otherPhone: '9000000000',
      phone: '9876543210',
      pocEmail: 'hr@company.com',
      pocUserId: 'USR-001',
      source: 'LinkedIn',
      state: 'Tamil Nadu',
      status: 'Active',
      workAuth: 'H1B',
      workAuthId: 'AUTH-001',
      workPhone: '044-87654321',
      workPreference: 'Remote',
      workStatus: {
        id: 'ws-001',
        name: 'Full-Time',
        status: true,
      },
    },
    id: 'sub-001',
    interviewRecommended: 'Yes',
    isShortlisted: true,
    isSubmitted: true,
    matchPercentage: 92,
    rank: 1,
    recommendation: 'Highly Recommended',
    shortlistedAt: '2025-02-15',
    shortlistedUser: {
      empCode: 'EMP102',
      firstName: 'Arun',
      id: 'usr-102',
      lastName: 'Raj',
      roleId: 3,
    },
    status: true,
    submittedAt: '2025-02-10',
    submittedUser: {
      empCode: 'EMP101',
      firstName: 'Priya',
      id: 'usr-101',
      lastName: 'Kumar',
      roleId: 2,
    },
  },
  {
    candidate: {
      aadharNumber: 223344556677,
      address: '456 IT Avenue',
      applicantId: 'APP-102',
      applicantStatus: 'Active',
      applicantStatusDate: '2025-02-08',
      benchAge: '1 week',
      benchAvailability: '2 weeks',
      benchId: 'BEN-102',
      benchStatus: 'Available',
      candidateSkills: [
        {
          candidateId: 'cand-002',
          id: 'cs-003',
          skill: {
            alias: {
              id: 'alias-003',
              name: 'Backend',
            },
            id: 'skill-003',
            name: 'Node.js',
            primary: true,
            status: true,
          },
        },
        {
          candidateId: 'cand-002',
          id: 'cs-004',
          skill: {
            alias: {
              id: 'alias-004',
              name: 'Database',
            },
            id: 'skill-004',
            name: 'MongoDB',
            primary: false,
            status: true,
          },
        },
      ],
      ceipalId: 'CEI-102',
      city: 'Bangalore',
      consultantName: 'InnovateHR',
      country: 'India',
      countryCode: '+91',
      email: 'anita.ramesh@example.com',
      firstName: 'Anita',
      homePhone: '080-12345678',
      id: 'cand-002',
      lastName: 'Ramesh',
      middleName: '',
      mobileNumber: '9988776655',
      organizationId: 'ORG-002',
      otherName: 'AR',
      otherPhone: '9444455555',
      phone: '9988776655',
      pocEmail: 'manager@company.com',
      pocUserId: 'USR-002',
      source: 'Referral',
      state: 'Karnataka',
      status: 'Active',
      workAuth: 'Citizen',
      workAuthId: 'AUTH-002',
      workPhone: '080-87654321',
      workPreference: 'Hybrid',
      workStatus: {
        id: 'ws-002',
        name: 'Contract',
        status: true,
      },
    },
    id: 'sub-002',
    interviewRecommended: 'Yes',
    isShortlisted: true,
    isSubmitted: true,
    matchPercentage: 87,
    rank: 2,
    recommendation: 'Recommended',
    shortlistedAt: '2025-02-18',
    shortlistedUser: {
      empCode: 'EMP202',
      firstName: 'Sujatha',
      id: 'usr-202',
      lastName: 'B',
      roleId: 3,
    },
    status: true,
    submittedAt: '2025-02-12',
    submittedUser: {
      empCode: 'EMP201',
      firstName: 'Karthik',
      id: 'usr-201',
      lastName: 'S',
      roleId: 2,
    },
  },
  {
    candidate: {
      aadharNumber: 334455667788,
      address: '789 Tech Valley',
      applicantId: 'APP-103',
      applicantStatus: 'Inactive',
      applicantStatusDate: '2025-02-28',
      benchAge: '3 weeks',
      benchAvailability: '1 month',
      benchId: 'BEN-103',
      benchStatus: 'Unavailable',
      candidateSkills: [
        {
          candidateId: 'cand-003',
          id: 'cs-005',
          skill: {
            alias: {
              id: 'alias-005',
              name: 'Frontend',
            },
            id: 'skill-005',
            name: 'Angular',
            primary: true,
            status: true,
          },
        },
        {
          candidateId: 'cand-003',
          id: 'cs-006',
          skill: {
            alias: {
              id: 'alias-006',
              name: 'Backend',
            },
            id: 'skill-006',
            name: 'Express.js',
            primary: false,
            status: true,
          },
        },
      ],
      ceipalId: 'CEI-103',
      city: 'Hyderabad',
      consultantName: 'TalentCorp',
      country: 'India',
      countryCode: '+91',
      email: 'rahul.singh@example.com',
      firstName: 'Rahul',
      homePhone: '040-12345678',
      id: 'cand-003',
      lastName: 'Singh',
      middleName: 'M.',
      mobileNumber: '9777777777',
      organizationId: 'ORG-003',
      otherName: 'RS',
      otherPhone: '9555555555',
      phone: '9777777777',
      pocEmail: 'lead@company.com',
      pocUserId: 'USR-003',
      source: 'Naukri',
      state: 'Telangana',
      status: 'Inactive',
      workAuth: 'Citizen',
      workAuthId: 'AUTH-003',
      workPhone: '040-98765432',
      workPreference: 'Onsite',
      workStatus: {
        id: 'ws-003',
        name: 'Part-Time',
        status: true,
      },
    },
    id: 'sub-003',
    interviewRecommended: 'No',
    isShortlisted: false,
    isSubmitted: true,
    matchPercentage: 81,
    rank: 3,
    recommendation: 'Average',
    shortlistedAt: '2025-03-03',
    shortlistedUser: {
      empCode: 'EMP302',
      firstName: 'Raj',
      id: 'usr-302',
      lastName: 'T',
      roleId: 3,
    },
    status: false,
    submittedAt: '2025-03-01',
    submittedUser: {
      empCode: 'EMP301',
      firstName: 'Meena',
      id: 'usr-301',
      lastName: 'K',
      roleId: 2,
    },
  },
  {
    candidate: {
      aadharNumber: 445566778899,
      address: '123 South Street',
      applicantId: 'APP-104',
      applicantStatus: 'Active',
      applicantStatusDate: '2025-03-05',
      benchAge: '1 week',
      benchAvailability: 'Immediate',
      benchId: 'BEN-104',
      benchStatus: 'Available',
      candidateSkills: [
        {
          candidateId: 'cand-004',
          id: 'cs-007',
          skill: {
            alias: {
              id: 'alias-007',
              name: 'Backend',
            },
            id: 'skill-007',
            name: 'Python',
            primary: true,
            status: true,
          },
        },
      ],
      ceipalId: 'CEI-104',
      city: 'Madurai',
      consultantName: 'SkillBridge',
      country: 'India',
      countryCode: '+91',
      email: 'suresh.kannan@example.com',
      firstName: 'Suresh',
      homePhone: '0452-1234567',
      id: 'cand-004',
      lastName: 'Kannan',
      middleName: '',
      mobileNumber: '9666666666',
      organizationId: 'ORG-004',
      otherName: 'SK',
      otherPhone: '9555443322',
      phone: '9666666666',
      pocEmail: 'staff@company.com',
      pocUserId: 'USR-004',
      source: 'Internal',
      state: 'Tamil Nadu',
      status: 'Active',
      workAuth: 'Citizen',
      workAuthId: 'AUTH-004',
      workPhone: '0452-7654321',
      workPreference: 'Remote',
      workStatus: {
        id: 'ws-004',
        name: 'Intern',
        status: true,
      },
    },
    id: 'sub-004',
    interviewRecommended: 'No',
    isShortlisted: false,
    isSubmitted: true,
    matchPercentage: 77,
    rank: 4,
    recommendation: 'Consider Later',
    shortlistedAt: '2025-03-12',
    shortlistedUser: {
      empCode: 'EMP402',
      firstName: 'Vijay',
      id: 'usr-402',
      lastName: 'S',
      roleId: 3,
    },
    status: false,
    submittedAt: '2025-03-10',
    submittedUser: {
      empCode: 'EMP401',
      firstName: 'Deepa',
      id: 'usr-401',
      lastName: 'N',
      roleId: 2,
    },
  },
  {
    candidate: {
      aadharNumber: 556677889900,
      address: '99 North Road',
      applicantId: 'APP-105',
      applicantStatus: 'Inactive',
      applicantStatusDate: '2025-03-18',
      benchAge: '4 weeks',
      benchAvailability: '1 month',
      benchId: 'BEN-105',
      benchStatus: 'Unavailable',
      candidateSkills: [
        {
          candidateId: 'cand-005',
          id: 'cs-008',
          skill: {
            alias: {
              id: 'alias-008',
              name: 'Backend',
            },
            id: 'skill-008',
            name: 'Java',
            primary: true,
            status: true,
          },
        },
        {
          candidateId: 'cand-005',
          id: 'cs-009',
          skill: {
            alias: {
              id: 'alias-009',
              name: 'Framework',
            },
            id: 'skill-009',
            name: 'Spring Boot',
            primary: false,
            status: true,
          },
        },
      ],
      ceipalId: 'CEI-105',
      city: 'Pune',
      consultantName: 'HireTech',
      country: 'India',
      countryCode: '+91',
      email: 'leena.george@example.com',
      firstName: 'Leena',
      homePhone: '020-12345678',
      id: 'cand-005',
      lastName: 'George',
      middleName: 'P.',
      mobileNumber: '9555332211',
      organizationId: 'ORG-005',
      otherName: 'LG',
      otherPhone: '9999988888',
      phone: '9555332211',
      pocEmail: 'recruit@company.com',
      pocUserId: 'USR-005',
      source: 'Job Portal',
      state: 'Maharashtra',
      status: 'Inactive',
      workAuth: 'Citizen',
      workAuthId: 'AUTH-005',
      workPhone: '020-87654321',
      workPreference: 'Onsite',
      workStatus: {
        id: 'ws-005',
        name: 'Freelancer',
        status: true,
      },
    },
    id: 'sub-005',
    interviewRecommended: 'No',
    isShortlisted: false,
    isSubmitted: true,
    matchPercentage: 70,
    rank: 5,
    recommendation: 'Not Suitable',
    shortlistedAt: '2025-03-22',
    shortlistedUser: {
      empCode: 'EMP502',
      firstName: 'Manoj',
      id: 'usr-502',
      lastName: 'A',
      roleId: 3,
    },
    status: false,
    submittedAt: '2025-03-20',
    submittedUser: {
      empCode: 'EMP501',
      firstName: 'Kiran',
      id: 'usr-501',
      lastName: 'V',
      roleId: 2,
    },
  },
];

export const MATCH = [
  {
    bgColor: '#F24B4B',
    borderColor: '#FF6C2D',
    key: 'noMatches',
    label: 'No Matches',
  },
  {
    bgColor: '#43A047',
    borderColor: '#43A047',
    key: 'submitted',
    label: 'Submitted',
  },
  {
    bgColor: '#FF6C2D',
    borderColor: '#FF6C2D',
    key: 'matchesFound',
    label: 'Matches Found',
  },
];
